module.exports = __webpack_public_path__ + "static/media/slideshow (3).ba71ed91.png";